import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=20ad11b8&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=ts"
export * from "./tabs.vue?vue&type=script&lang=ts"
import style0 from "./tabs.vue?vue&type=style&index=0&id=20ad11b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad11b8",
  null
  
)

export default component.exports